// This icon file is generated automatically.
var PUpSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M4.22 8.75h.73a.5.5 0 00.4-.2L7 6.26l1.64 2.27c.1.13.25.21.4.21h.74c.1 0 .16-.12.1-.2L7.1 4.71a.12.12 0 00-.2 0L4.12 8.55c-.06.08 0 .2.1.2z" } }, { "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zm-.63 11.38H1.88V1.87h10.25v10.25z" } }] }] }, "name": "p-up-square", "theme": "outlined" };
export default PUpSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PUpSquareOutlined.js
// module id = 3715
// module chunks = 0